export enum ReportsDisplayType {
  map = 'map',
  list = 'list',
}
